export default __webpack_public_path__ + "static/media/gia_thue_xe_tu_lai_4cho_tai_hanoi.e6ebc385.png";